import { render, staticRenderFns } from "./AdvantageTotal.vue?vue&type=template&id=5de6966b&scoped=true&"
import script from "./AdvantageTotal.vue?vue&type=script&lang=js&"
export * from "./AdvantageTotal.vue?vue&type=script&lang=js&"
import style0 from "./AdvantageTotal.vue?vue&type=style&index=0&id=5de6966b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de6966b",
  null
  
)

export default component.exports